<footer class="footer">
  <div class="container-fluid">
    <nav class="pull-left">
      <ul>
        <li>
          <a #href> 1 </a>
        </li>
        <li>
          <a #href> 2 </a>
        </li>
        <li>
          <a #href> 3 </a>
        </li>
      </ul>
    </nav>
    <div class="copyright pull-right">
      &copy;
      <a #href target="_blank">{{'general.copyright' | translate}}</a>
    </div>
  </div>
</footer>